import Conditional from "@repo/shared-ui/Conditional";

const Nudge = ({ count, className }: { count: number, className?: string }) => {
  return (
    <Conditional if={count > 0}>
      <div className={`rounded-[12px] w-[24px] h-[24px] flex items-center justify-center p-[4px] bg-[#089E86] text-white font-normal text-[12px] leading-[18px] max-md:w-[20px] max-md:h-[20px] max-md:text-[10px] ${className}`}>
        {count}
      </div>
    </Conditional>
  );
}


export default Nudge;